export const enabledKaiTooltip = 'Enables the display of the Kai AI Assistant on the platform within the organization. The source for the Kai Assistant can be configured by the manager on the Kai platform. Please contact the manager for more details.';

export const hideKaiTooltip = 'When enabled, this setting hides Kai Assistant tab for users in this organisation. They won’t be able to view or modify AI assistant preferences.';

export const kaiAssistantSelectValues = {
	isKaiAssistantEnabled: 'isKaiAssistantEnabled',
	isKaiAssistantHidden: 'isKaiAssistantHidden',
} as const;
